export enum UPLOAD_STATUS {
    INITIAL_LOAD,
    UPLOADING,
    FINISHED,
    ERROR
}

export enum FILE_EXPLORER_OPTIONS {
    CALC_DIFF = 'Calculate difference',
    CHARTS = 'Add charts',
    NONE = 'None'
}